import * as React from 'react';
import { formatoDecimal } from "../../../../utilities/formatoNumeros";

export default class DetalleLiquidacionEditar extends React.Component {
    render = () => {
        const { liquidacion, isBorrador, esContaduria } = this.props;

        return (
            <div className="row">
                <div className="col-12 col-sm-6">
                    <ul className="list-group">
                        <li className="list-group-item">
                            <span className={`badge rounded-pill text-bg-${liquidacion.cantidadOrdenes === 0 ? "secondary" : "primary"}`}>
                                {liquidacion.cantidadOrdenes}
                                {liquidacion.cantidadOrdenes === 1 ? " Orden" : " Órdenes"}
                            </span>
                            <span className={`mx-2 badge rounded-pill text-bg-${liquidacion.cantidadNovedades === 0 ? "secondary" : "primary"}`}>
                                {liquidacion.cantidadNovedades}
                                {liquidacion.cantidadNovedades === 1 ? " Novedad" : " Novedades"}
                            </span>
                            {liquidacion.idTipoEstadoLiquidacion === 3 && (
                                <span className="badge rounded-pill text-bg-success mx-2">
                                    Liquidación Confirmada
                                </span>
                            )}
                        </li>
                        <li className="list-group-item">
                            <h5 className="card-title">N° Liquidación: {liquidacion.idLiquidacion}</h5>
                        </li>
                        <li className="list-group-item">
                            <h5 className="card-title">Seller: {liquidacion.razonSocialSeller}</h5>
                        </li>
                        <li className="list-group-item">
                            <h5 className="card-title">Fecha: {liquidacion.mostrarFecha}</h5>
                        </li>
                    </ul>

                    {isBorrador && liquidacion.idTipoEstadoLiquidacion !== 3 &&
                        <div className="alert alert-warning d-flex align-items-center mt-3 shadow-sm border-0" role="alert">
                            <i className="fa fa-exclamation-circle me-2" style={{ fontSize: '1.2rem' }}></i>
                            <div>
                                <strong>Atención:</strong> Liquidación pendiente de confirmar
                            </div>
                        </div>
                    }

                    {this.props.children}
                </div>

                <div className="col-12 col-sm-6">
                    <ul className="list-group">
                        <DetailItem label="Total Ordenes" value={liquidacion.totalOrden} />
                        <DetailItem label="Comision Neta" value={liquidacion.comisionNeta} />
                        <DetailItem label="Comision Total a Facturar" value={liquidacion.comisionTotal} />
                        <DetailItem label="Costo Fee Neto" value={liquidacion.totalCostoFeeNeto} />
                        <DetailItem label="Total Costo Fee Con Iva" value={liquidacion.totalCostoFee} />
                        <DetailItem label="Novedades Con Iva" value={liquidacion.totalNovedades} />
                        <DetailItem label="Neto A Pagar" value={liquidacion.totalLiquidacion} />
                        <DetailItem label="Total Rebate Con Iva" value={liquidacion.totalRebateConIva} />
                        <DetailItem label="Total Retenciones" value={liquidacion.totalRetenciones} />
                        <li className="list-group-item">
                            Total Percepciones: <strong>${formatoDecimal(liquidacion.totalPercepcion)}</strong>
                            {/*esContaduria &&*/ liquidacion.totalPercepcion > 0 && (
                                <i
                                    className="fa fa-clipboard ms-2"
                                    aria-hidden="true"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                        this.props.onVerDetallePercepciones(this.props.liquidacion.idLiquidacion, "liquidacion")
                                    }
                                />
                            )}
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

function DetailItem({ label, value }) {
    const formatValue = `$${formatoDecimal(value)}`;
    return (
        <li className="list-group-item">
            {label}: <strong>{formatValue}</strong>
        </li>
    );
}
